import { render, staticRenderFns } from "./DvBorderBox.vue?vue&type=template&id=d3520ec0"
import script from "./DvBorderBox.vue?vue&type=script&lang=js"
export * from "./DvBorderBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports